import { useStoreon } from 'storeon/react';
import { Experiment } from 'types/model';
import { APPSFLYER_SCRIPT_INTERNAL_ID } from 'common/constants/experiment';
import { useEffect, useMemo } from 'react';
import { addAppsflyerScript } from './add-appsflyer-script';

export const DEFAULT_Z_INDEX = 999;

type Model = {
  model: { experiments: ExperimentType[] } | undefined;
};

type ExperimentType = {
  internalId: string;
  externalId: string;
};

const createConfig = (value?: ExperimentType) => {
  if (value === undefined) return undefined;

  const [apiKey, zIndex] = value.externalId.split(',');
  return {
    apiKey,
    zIndex: parseInt(zIndex) || DEFAULT_Z_INDEX,
  };
};

export const useAppsflyerScript = (disableAppsflyer?: boolean) => {
  const { model } = useStoreon<Model>('model');

  const config = useMemo(() => {
    const result = model?.experiments?.find(
      ({ internalId }: Experiment) => internalId === APPSFLYER_SCRIPT_INTERNAL_ID,
    );

    return createConfig(result);
  }, [model]);

  useEffect(() => {
    if (disableAppsflyer) return;

    if (config !== undefined) {
      addAppsflyerScript(config.apiKey, config.zIndex);
    }
  }, [disableAppsflyer, config]);
};
